"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));
var _text = require("@mmc/text");
var _editorialContentGrid = _interopRequireDefault(require("../styles/editorial-content-grid.css"));
var _editorialContentGrid2 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.defaultProps"));
var _editorialContentGrid3 = _interopRequireDefault(require("./editorial-content-grid.props/editorial-content-grid.propTypes"));
var _gridCard = _interopRequireDefault(require("./grid-card"));
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
  renderEmptyString = dataUtils.renderEmptyString;
var EditorialContentGrid = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(EditorialContentGrid, _React$Component);
  function EditorialContentGrid() {
    return _React$Component.apply(this, arguments) || this;
  }
  EditorialContentGrid.resourceType = function resourceType() {
    return 'EditorialCards_1_0_0';
  };
  var _proto = EditorialContentGrid.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      theme = _this$props.theme,
      defaultData = _this$props.defaultData;
    var componentData = shouldUseDataOrDefaultProps(data, defaultData);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: theme['container-fluid'] + " " + _editorialContentGrid["default"].gridWrapper,
      automation: "automationValue"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "" + theme.row
    }, renderEmptyString(componentData.columns) !== ' ' && /*#__PURE__*/_react["default"].createElement(_gridCard["default"], {
      cards: componentData.columns,
      theme: theme,
      disclaimerData: data.disclaimerData
    })));
  };
  return EditorialContentGrid;
}(_react["default"].Component);
exports["default"] = EditorialContentGrid;
EditorialContentGrid.displayName = 'EditorialContentGrid';
EditorialContentGrid.defaultProps = {
  data: _editorialContentGrid2["default"],
  defaultData: _editorialContentGrid2["default"]
};